
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultations/expert/[slug]",
      function () {
        return require("private-next-pages/consultations/expert/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultations/expert/[slug]"])
      });
    }
  